import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export function freeCampaignUntilPacificTime(pacificIso: string): string {
  const pacificDate = new Date(pacificIso);
  return pacificDate
    .toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace("AM", "a.m.")
    .replace("PM", "p.m.");
}

export function freeCampaignUntilUTC(pacific: string): string {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const pacificTime = dayjs.tz(pacific, "America/Los_Angeles");
  const utcTime = pacificTime.utc();

  // Format to 12-hour with lowercase a.m./p.m. + 'UTC'
  return (
    utcTime
      .format("h:mm A")
      .toLowerCase()
      .replace("am", "a.m.")
      .replace("pm", "p.m.") + " UTC"
  );
}

export function freeCampaignUntilEasternTime(pacific: string): string {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const pacificTime = dayjs.tz(pacific, "America/Los_Angeles");
  const easternTime = pacificTime.tz("America/New_York");

  // Format to 12-hour with lowercase a.m./p.m. + 'ET'
  return (
    easternTime
      .format("h:mm A")
      .toLowerCase()
      .replace("am", "a.m.")
      .replace("pm", "p.m.") + " Eastern Time"
  );
}

export function freeCampaignDatePacificTime(pacific: string): string {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const pacificTime = dayjs.tz(pacific, "America/Los_Angeles");

  // Format to "March 26, 2026" in Pacific Time
  return pacificTime.format("MMMM D, YYYY");
}

export function freeCampaignDateShortPacificTime(pacific: string): string {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const pacificTime = dayjs.tz(pacific, "America/Los_Angeles");

  // Format to "Jan 5, 2026" in Pacific Time (short month format)
  return pacificTime.format("MMM D, YYYY");
}
